import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import { Dropdown, Slider } from 'antd';
import HoverIcon from '../HoverIcon';
import { findIndex } from 'lodash-es';
import { useIntl } from 'umi';
interface FontSliderProps {
  onChange: any;
  value: number;
}

export const SIZE = [15, 17, 20, 24, 30];
const FontSlider: React.FC<FontSliderProps> = inject(({ store }) => {
  return {
    barrage: store.barrage,
  };
})(
  observer((props: FontSliderProps) => {
    const { onChange, value } = props;
    const [visible, setVisible]= useState<boolean>(false)
    const [progress, setProgress] = useState<number>();
    const { formatMessage } = useIntl();
    const getSize = (pregress: number) => {
      if (pregress === 0) {
        return SIZE[0];
      } else if (pregress <= 25) {
        return SIZE[1];
      } else if (pregress <= 50) {
        return SIZE[2];
      } else if (pregress <= 75) {
        return SIZE[3];
      } else {
        return SIZE[4];
      }
    };
    const handleChange = (progress: number) => {
      setProgress(progress);
      onChange(getSize(progress));
    };

    const dropdownRender = () => (
      <span className={s.wrapper}>
        <span className={s.text}>{formatMessage({ id: 'fontSize' })}</span>
        <div className={s.sliderWrapper}>
          <span className={s.size}>{formatMessage({ id: 'small' })}</span>
          <Slider
            value={progress}
            onChange={handleChange}
            min={0}
            max={100}
            tooltip={{ open: false }}
            marks={{
              0: {
                label: <span></span>,
              },
              25: {
                label: <span></span>,
              },
              50: {
                label: <span></span>,
              },
              75: {
                label: <span></span>,
              },
              100: {
                label: <span></span>,
              },
            }}
            step={25}
            className={s.slider}
            handleStyle={{ background: 'white' }}
          />
          <span className={s.size}>{formatMessage({ id: 'big' })}</span>
        </div>
      </span>
    );
    const handleVisibleChange = (value:boolean) =>
    {
      setVisible(value)
    }

    useEffect(() => {
      const index = findIndex(SIZE, (v) => v === value);
      return setProgress(index * 25);
    }, []);

    return (
      <div className={s.container}>
        <Dropdown
          placement="top"
          trigger={['click']}
          dropdownRender={dropdownRender}
          overlayClassName={s.dropdown}
          arrow={false}
          onVisibleChange={handleVisibleChange}
        >
          <HoverIcon
            panelVisible={visible}
            name="icon-textStyle_1"
            title={formatMessage({ id: 'fontSize' })}
            style={{ marginRight: '8px', marginLeft: '8px' }}
          ></HoverIcon>
        </Dropdown>
      </div>
    );
  })
);

export default FontSlider;
